import React from 'react';
import PropTypes from 'prop-types';
import { AuthProvider, useAuth } from 'react-oidc-context';
import { Loader } from "stateless/loader";
import {useHistory, useLocation} from "react-router-dom";

const AuthenticationInner = ({ children }) => {
	const auth = useAuth();


	if (auth.isLoading || auth.error) {
		return <Loader active />;
	}

	if (auth.isAuthenticated) {
		return children;
	}
	return <SigninRedirect />;
};

AuthenticationInner.propTypes = {
	children: PropTypes.node.isRequired,
};

const SigninRedirect = () => {
	const auth = useAuth();
	const { pathname } = useLocation();
	React.useEffect(() => {
		auth.signinRedirect({
			url_state: String(pathname)
		});
	}, [auth, pathname]);
	return null;
};

export const Authentication = ({ children, redirectPath, config }) => {

	const history = useHistory();
	const onSigninCallback = user => {
		const dest = user.url_state || '/';
		history.push(dest);
	};

	return (
		<AuthProvider
			automaticSilentRenew
			authority={ config.OIDCUrl }
			redirect_uri={ `${window.location.origin}/target/` }
			onSigninCallback={ onSigninCallback }
			client_id={ config.clientId }
		>
			<AuthenticationInner>{children}</AuthenticationInner>
		</AuthProvider>
	);
};

Authentication.propTypes = {
	children: PropTypes.node.isRequired,
	redirectPath: PropTypes.string.isRequired,
	config: PropTypes.shape({
		OIDCUrl: PropTypes.string,
		clientId: PropTypes.string
	}).isRequired
};
